// extracted by mini-css-extract-plugin
export default {"modalWrapper":"OrderDetail_modalWrapper__VJFAa"};